import { MurfInputLabel } from "@/components/elements/MurfInputLabel";
import { Box, Button, ButtonGroup, Typography } from "@mui/material";

interface OptionsProps {
  options: {
    title: string;
    value: string;
    description?: string;
  }[];
  label: string;
  onChange: (value: string) => void;
  selectedValue: string;
  fullWidth?: boolean;
}

const Options = ({
  options,
  label,
  onChange,
  selectedValue,
  fullWidth
}: OptionsProps) => {
  return (
    <>
      {label ? <MurfInputLabel sx={{ mb: 1 }}>{label}</MurfInputLabel> : null}
      <Box display="flex" gap={1} alignItems="center">
        <ButtonGroup fullWidth={fullWidth} sx={{ width: fullWidth ? "100%" : "auto" }}>
          {options.map((option) => (
            <Button
              variant="contained"
              color="secondary"
              onClick={() => onChange(option.value)}
              key={option.value}
              sx={{
                flex: fullWidth ? 1 : "initial",
                backgroundColor:
                  selectedValue === option.value ? "secondary.main" : "",
                color:
                  selectedValue === option.value
                    ? "secondary.contrastText"
                    : "",
                "&:hover": {
                  backgroundColor: "secondary.main",
                  color: "secondary.contrastText"
                },
                boxShadow: "none",
                textTransform: "none",
                fontWeight: 600
              }}
            >
              {option.title}
            </Button>
          ))}
        </ButtonGroup>
        {options.find((option) => option.value === selectedValue)
          ?.description ? (
          <Typography variant="body2" color="text.secondary">
            {
              options.find((option) => option.value === selectedValue)
                ?.description
            }
          </Typography>
        ) : null}
      </Box>
    </>
  );
};

export default Options;
